import { render, staticRenderFns } from "./AssemblyView.vue?vue&type=template&id=dda089a4"
import script from "./AssemblyView.vue?vue&type=script&lang=ts"
export * from "./AssemblyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports